const validateFormTextField = (
  field: string,
  configs: { form: { [field: string]: { [fieldKey: string]: any } } },
  state: { value: string; hasError: boolean; error: string }
): boolean => {
  let validationError = false

  const {
    form: {
      [field]: { errorTypes }
    }
  } = configs

  const { value } = state

  if (errorTypes.required && !value) {
    validationError = true
  } else if (errorTypes.minChar && value.length < errorTypes.minChar) {
    validationError = true
  } else if (errorTypes.maxChar && value.length > errorTypes.maxChar) {
    validationError = true
  }

  return validationError
}

const validateFormPhoneField = (
  field: string,
  configs: { form: { [field: string]: { [fieldKey: string]: any } } },
  state: { value: string; hasError: boolean; error: string }
): boolean => {
  let validationError = false

  const {
    form: {
      [field]: { errorTypes }
    }
  } = configs

  const { value } = state
  const phone = value === '+1' ? '' : value

  if (errorTypes.required && !phone) {
    validationError = true
  } else if (phone && phone.length < 12) {
    validationError = true
  } else if (phone && phone.length > 12) {
    validationError = true
  } else if (phone && phone.slice(0, 2) !== '+1') {
    validationError = true
  }

  return validationError
}

const validateFormField = (
  field: string,
  configs: { form: { [field: string]: { [fieldKey: string]: any } } },
  state: { value: string; hasError: boolean; error: string }
): boolean => {
  const {
    form: {
      [field]: {
        errorTypes: { type }
      }
    }
  } = configs

  if (type === 'phone') {
    return validateFormPhoneField(field, configs, state)
  }

  return validateFormTextField(field, configs, state)
}

export default validateFormField
